import React, { FC } from 'react';
import { createStyles, makeStyles } from '@material-ui/core';
import { ExtendedTheme, Heading, TextBlock } from 'neon-design-system';
import PublishedBy, { PublishedByProps } from './PublishedBy';
import ShareArticleActions from './ShareArticleActions';
import { Channel } from '../../shared/types';

const useStyles = makeStyles((theme: ExtendedTheme) => createStyles({
	title: {
		marginBottom: theme.spacing(2),
		[theme.breakpoints.up('md')]: {
			marginBottom: theme.spacing(2)
		},
		'@media print': {
			'& h1': {
				color: theme.themeColors.grey[900]
			}
		}
	},
	summary: {
		marginBottom: theme.spacing(2),
		'@media print': {
			fontSize: theme.typography.h3.fontSize
		}
	},
	publishedBy: {
		marginBottom: theme.spacing(2)
	}
}));

export interface ArticleHeaderProps {
	title: string;
	summary: string;
	id: string;
	publishedData: PublishedByProps;
	channel?: Channel;
	chartsArticle?: boolean;
}

const ArticleHeader: FC<ArticleHeaderProps> = ({ title, summary, id, publishedData, channel, chartsArticle }) => {
	const classes = useStyles();

	return (
		<>
			<div className={classes.title} id={'article-page-title'}>
				<Heading styleName="largeTitle" xs="small" md="medium" xl="large" color="white">
					{title}
				</Heading>
			</div>
			<TextBlock
				className={classes.summary}
				color="grey"
				shade={200}
				styleName="largeBody2"
				xs="small"
				md="medium"
				xl="large"
			>
				<span id={'article-page-summary'}>{summary}</span>
			</TextBlock>
			<div
				id={'article-page-published-by'}
				className={classes.publishedBy}>
				<PublishedBy
					styleName="caption1"
					date={publishedData.date}
					publisher={publishedData.publisher}
					momentInTimeFormat={publishedData.momentInTimeFormat}
					showEditDate={publishedData.showEditDate}
					editDate={publishedData.editDate}
					channel={channel}
					disabledPublishedDate={!chartsArticle}
				/>
			</div>
			{!chartsArticle ? (
				<ShareArticleActions articleTitle={title} articleId={id} />
			) : <></>}
		</>
	);

};

export default ArticleHeader;
